import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PaginationInstance } from 'ngx-pagination';
import { BankDetail, JobPreferenceDetail } from 'src/app/model/employees';
import { GlobalService } from 'src/app/services/global/global.service';
import { AddBankDetailComponent } from '../add-bank-detail/add-bank-detail.component';
import { AddJobPreferenceComponent } from '../add-job-preference/add-job-preference.component';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { ConfirmationModalComponent } from '../../dialog-modal/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-job-preference-detail',
  templateUrl: './job-preference-detail.component.html',
  styleUrls: ['./job-preference-detail.component.scss']
})
export class JobPreferenceDetailComponent {
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public imageURL: any = GlobalService.imageURL;
  // public displayedColumns: string[] = ['acc_no', 'bank_name', 'iban', 'sort_code', 'pps_number', 'action'];
  public displayedColumns: string[] = ['job_category', 'time', 'status', 'shift', 'interested', 'willing_travel'];
  public dataSource = new MatTableDataSource<JobPreferenceDetail>();
  public count!: any;
  public listArr: JobPreferenceDetail[] = []
  @Input() employeeId!:string|number;
  isInitialLoad = false;
  public searchInput: string = '';
  private previousInputValue: string = '';

  constructor( @Inject(MAT_DIALOG_DATA) public dialogData: any, public dialog: MatDialog, private appService: AppService, private commonService: CommonService,
  private recruiterService:RecruiterService,) { }

  ngOnInit(): void {
    this.isInitialLoad=true;
    this.dataSource = new MatTableDataSource<JobPreferenceDetail>(this.listArr);
    this.getList()
  }

  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.getList();
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    if (this.isInitialLoad==true) {
      this.isInitialLoad=false;
      return
    }
    this.getList();
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage = 1
      this.getList()
    }
  }
  onGo() {
    if (this.searchInput.trim() != '') {
      this.config.currentPage = 1
      this.getList()
    }
  }
  onAddBank() {
    const dialogRef = this.dialog.open(AddJobPreferenceComponent, {
       width: '80%',
      height: '98%',
      maxWidth:'660px',
      maxHeight:"680px",
      data:this.employeeId,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getList()
      }
    });
  }
  onDeleteItem(itemId: any) { 
    const dialogRef = this.dialog.open(DeleteItemComponent, {
      data: {  api_type: 'delete_content',content_type: 'delete_profile', em_i: this.employeeId, id: itemId,  },
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList()
      }
    });
  }

  getList() {
    // this.spinner.show();
    let obj = {
      em_i: this.employeeId,
      start: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: [],
      sh: this.searchInput.trim(),
    }
    this.recruiterService.getProfileList(obj).subscribe({
      next: (success: any) => {
        //this.spinner.hide()
        this.dataSource = new MatTableDataSource(success.msg)
        this.count = success.count
        this.previousInputValue = this.searchInput;
      },
      error: (error: any) => {
        this.dataSource.data = [];
        this.previousInputValue = this.searchInput;
        this.commonService.handleError(error);
      },
    });
  }

  profileAcceptReject(type,value,item){
    if(value==item.app){return}
    // status is approved still user pressess accept button then no need to change the api 
    let dataObj={
      em_i:this.employeeId,
      app:value,
      id:item.id
    };
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: {  content_type:'accept_reject',data_type:type , dataObj:dataObj,item_type:"role"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList()
      }
    });
  }
}